import { render } from "./linkedinSquare.vue?vue&type=template&id=51bf0de3&scoped=true"
import script from "./linkedinSquare.vue?vue&type=script&lang=js"
export * from "./linkedinSquare.vue?vue&type=script&lang=js"

import "./linkedinSquare.vue?vue&type=style&index=0&id=51bf0de3&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bf0de3"]])

export default __exports__